import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/sitemap")({
  head: () => buildRouteHead("/en/sitemap", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/sitemap", replace: true });
  },
});
